import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export type HourlyScreenComponent = FunctionComponent<HourlyScreenProps>

export type HourlyScreenProps = RootStackScreenComponentProps<'Hourly'>

export type ResponsiveHourlyScreenComponent = FunctionComponent<ReturnType<UseHourlyScreen>>

export type UseHourlyScreen = ({ navigation }: Pick<HourlyScreenProps, 'navigation' | 'route'>) => {
  isMobile: boolean
  url?: string
}

export const HOURLY_URL =
  'https://app.powerbi.com/reportEmbed?reportId=322e1a6d-8160-405c-b6b9-d3f41cd6de82&appId=84438397-5da3-4842-aea5-e2cdd83ffd27&autoAuth=true&ctid=35595a02-4d6d-44ac-99e1-f9ab4cd872db'
